/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Public_Site_Back_BlogInputs */

const cs_public_site_back_blog = /** @type {(inputs: Public_Site_Back_BlogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zpět na blog`)
};

const en_public_site_back_blog = /** @type {(inputs: Public_Site_Back_BlogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Back to blog`)
};

/**
* | output |
* | --- |
* | "Back to blog" |
*
* @param {Public_Site_Back_BlogInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const public_site_back_blog = /** @type {((inputs?: Public_Site_Back_BlogInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Public_Site_Back_BlogInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_public_site_back_blog(inputs)
	return cs_public_site_back_blog(inputs)
});